module.exports = "<h1 id=\"数字输入框--d-input-number\">数字输入框  d-input-number</h1>\n";